export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly body?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'content-type': 'application/json', ...init?.headers },
    ...init,
  })
  if (res.status === 401) {
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      window.location.href = '/login'
    }
    throw new ApiError(401, 'Unauthorized')
  }
  const text = await res.text()
  const body = text ? (JSON.parse(text) as unknown) : undefined
  if (!res.ok) {
    throw new ApiError(res.status, `${res.status} ${res.statusText}`, body)
  }
  return body as T
}

export interface MeResponse {
  oid: string
  email: string
  displayName: string
}

export interface ServerSummary {
  slug: string
  name: string
  description: string
  enabled: boolean
  configured: boolean
}

export interface ConfigField {
  key: string
  label: string
  type: 'string' | 'secret'
  required: boolean
  placeholder?: string
}

export interface ServerDetail extends ServerSummary {
  configSchema: ConfigField[]
  mcpUrl: string
  oauthClientId: string
}
